import type { Dictionary, ParsedProperty } from '@witmetrics/utils';
import { isBlank } from '@witmetrics/utils/strings';

export const classes = {
  dialog: 'w-[98vw] max-w-[400px] min-w-[250px]',
  input: 'w-full mb-4',
  section: 'w-full py-3',
  selectDropdown: 'w-full',
  body: 'pt-0 pb-6 w-full min-h-0 overflow-auto',
  optional: 'my-4 text-base text-grey-8 dark:text-mauve-1 font-medium',
};

export function formatSelectValue(label: string) {
  return { value: label, label };
}

export function buildNewLeadProperties({
  practiceProperties,
  phone,
}: {
  practiceProperties: Dictionary<ParsedProperty>;
  phone: string;
}) {
  const getId = (key: keyof typeof practiceProperties) =>
    practiceProperties[key].id;
  let leadProperties: { propertyId: number; value: string }[] = [
    { propertyId: getId('enquiryStatus'), value: 'Treatment accepted' },
  ];
  if (!isBlank(phone)) {
    leadProperties.push({ propertyId: getId('phone'), value: phone });
  }
  return leadProperties;
}
